import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import firebase from 'firebase/compat/app';

import { apiUrl } from '../config';

// https://github.com/apollographql/apollo-feature-requests/issues/6#issuecomment-676886539
const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key, value) =>
      key === '__typename' ? undefined : value;
    operation.variables = JSON.parse(
      JSON.stringify(operation.variables),
      omitTypename
    );
  }
  return forward(operation);
});

export function createApolloClient() {
  const httpLink = createHttpLink({
    uri: `${apiUrl}/graphql`,
  });
  const authLink = setContext((_, { headers }) => {
    const user = firebase.auth().currentUser;
    if (!user) {
      return { headers };
    }
    return user
      .getIdToken()
      .then((token) => {
        return {
          headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : null,
          },
        };
      });
  });

  const client = new ApolloClient({
    link: ApolloLink.from([cleanTypeName, authLink, httpLink]),
    cache: new InMemoryCache({ addTypename: false }),
  });

  return client;
}
